import styled from 'styled-components'

export const Container = styled.div`
	form {
		display: flex;
		align-items: center;
		margin: 0 8px;

		span {
			margin-top: 14px;
		}

		> button {
			margin: 23px 8px 5px !important;

			&.icon-left {
				svg {
					margin: 0 8px 0 0 !important;
				}
			}

			@media(max-width: 600px) {
				margin: 12px 0 5px !important;
			}
		}
	}

	.table-container {
		width: calc(100% - 32px);
		margin: 12px 16px 0;

		table {
			margin-top: 0;
		}

		@media(max-width: 600px) {
			width: calc(100% - 16px);
			margin: 12px 8px 0;
		}
	}

	.form-inicial-container {
		display: flex;
		flex-direction: column;
		align-items: start;
	}
`

export const AddInstituicao = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: calc(70% - 16px);

	.locais {
		width: 100%;
	}

	button {
		margin-top: 24px;
	}

	@media(max-width: 700px) {
		width: calc(100% - 16px);
	}

	@media(max-width: 600px) {
		width: 100%;
		flex-direction: column;

		button {
			width: 100%;
			margin: 5px 8px !important;
			margin-top: 0;
		}

		+ button {
			width: calc(100% - 16px);
			margin: 5px 8px !important;
		}
	}
`

export const FormNovoLocal = styled.div`
	display: flex;	
	flex-direction: column;

	.novo-local-identificacao {
		display: grid;
		grid-template-columns: 1fr 1fr 2fr;

		@media(max-width: 800px) {
			display: flex;
			flex-direction: column;
		}
	}

	.form-endereco form {
		display: grid;
		margin: 0;
	}

	@media(max-width: 1100px) {
		> .field:first-child {
			width: calc(100% - 24px);
			margin-right: 0 !important;
		}
	}

	@media(max-width: 800px) {
		> .field:first-child {
			width: calc(100% - 16px);
			margin-right: 0 !important;
		}
	}
`
